const riot = require('riot');

riot.tag2('atom-markdown', '', 'atom-markdown,[data-is="atom-markdown"]{line-height:1.5} atom-markdown h5,[data-is="atom-markdown"] h5,atom-markdown h6,[data-is="atom-markdown"] h6{margin-top:16px;margin-bottom:8px} atom-markdown h1,[data-is="atom-markdown"] h1{padding-left:0;padding-bottom:4px} atom-markdown h2,[data-is="atom-markdown"] h2{position:relative;padding-top:calc(6px + var(--margin-y));padding-bottom:calc(8px + var(--margin-y));padding-left:16px;--margin-y:4px;mix-blend-mode:multiply} atom-markdown h2:before,[data-is="atom-markdown"] h2:before{position:absolute;left:0;top:var(--margin-y);z-index:-1;display:block;content:\'\';height:calc(100% - var(--margin-y) * 2);width:100%;background-color:#F5F7FC;border-left:6px solid var(--project-color, #4466ea)} atom-markdown h3,[data-is="atom-markdown"] h3{position:relative;padding-top:calc(2px + var(--margin-y));padding-bottom:4px;padding-left:12px !important;margin-bottom:4px;--margin-y:4px} atom-markdown h3:after,[data-is="atom-markdown"] h3:after{position:absolute;top:var(--margin-y);left:0;bottom:0;display:block;content:\'\';width:4px;background-color:var(--project-color, #4466ea);opacity:.7} atom-markdown h3:before,[data-is="atom-markdown"] h3:before{position:absolute;left:0;bottom:0;display:block;content:\'\';height:1px;width:100%;background-color:#d8e0eb} atom-markdown H4,[data-is="atom-markdown"] H4{position:relative;padding-top:4px;padding-bottom:8px} atom-markdown H4:before,[data-is="atom-markdown"] H4:before{position:absolute;left:0;bottom:6px;display:block;content:\'\';height:1px;width:100%;background-color:#d8e0eb} atom-markdown p,[data-is="atom-markdown"] p,atom-markdown img,[data-is="atom-markdown"] img,atom-markdown pre,[data-is="atom-markdown"] pre,atom-markdown blockquote,[data-is="atom-markdown"] blockquote,atom-markdown ul,[data-is="atom-markdown"] ul,atom-markdown ol,[data-is="atom-markdown"] ol,atom-markdown table,[data-is="atom-markdown"] table,atom-markdown hr,[data-is="atom-markdown"] hr{margin-bottom:16px} atom-markdown p:last-child,[data-is="atom-markdown"] p:last-child,atom-markdown img:last-child,[data-is="atom-markdown"] img:last-child,atom-markdown pre:last-child,[data-is="atom-markdown"] pre:last-child,atom-markdown blockquote:last-child,[data-is="atom-markdown"] blockquote:last-child,atom-markdown ul:last-child,[data-is="atom-markdown"] ul:last-child,atom-markdown ol:last-child,[data-is="atom-markdown"] ol:last-child,atom-markdown table:last-child,[data-is="atom-markdown"] table:last-child,atom-markdown hr:last-child,[data-is="atom-markdown"] hr:last-child{margin-bottom:0px} atom-markdown ul,[data-is="atom-markdown"] ul,atom-markdown ol,[data-is="atom-markdown"] ol{margin-left:16px} atom-markdown img,[data-is="atom-markdown"] img{border:1px solid #ccc;display:block;cursor:pointer} atom-markdown pre,[data-is="atom-markdown"] pre{position:relative;overflow:scroll;padding:12px 0px;color:white;border-radius:2px} atom-markdown pre code,[data-is="atom-markdown"] pre code{font-size:13px} atom-markdown :not(pre) code,[data-is="atom-markdown"] :not(pre) code{vertical-align:baseline;background-color:rgba(238,238,238,0.5);border-radius:4px;padding:1px 4px;border:#ccc solid 1px;color:#922;font-size:90%} atom-markdown blockquote,[data-is="atom-markdown"] blockquote{border-left:4px solid lightgray;padding:4px 8px} atom-markdown blockquote>:last-child,[data-is="atom-markdown"] blockquote>:last-child{margin-bottom:0px} atom-markdown table,[data-is="atom-markdown"] table{width:100%;border-collapse:collapse;font-family:Arial,Helvetica,sans-serif} atom-markdown table th,[data-is="atom-markdown"] table th{padding:10px 6px;background-color:var(--project-color, #4466ea);color:white;text-shadow:0 0 1.5px black;font-weight:bold;opacity:.6} atom-markdown table td,[data-is="atom-markdown"] table td{padding:6px;background-color:#fff} atom-markdown table tr:nth-child(even) td,[data-is="atom-markdown"] table tr:nth-child(even) td{background-color:#f2f2f2} atom-markdown table th,[data-is="atom-markdown"] table th,atom-markdown table td,[data-is="atom-markdown"] table td{border:1px solid #aaa} atom-markdown a,[data-is="atom-markdown"] a{color:#4af} atom-markdown a:hover,[data-is="atom-markdown"] a:hover{text-decoration:underline currentColor} atom-markdown .with-icon::after,[data-is="atom-markdown"] .with-icon::after{display:inline-block;content:\'\';width:12px;height:12px;background-image:url(\'/images/icons/comment_link_icon.png\');background-size:cover;margin:0 3px} atom-markdown a img,[data-is="atom-markdown"] a img{width:90%} atom-markdown a:has(img),[data-is="atom-markdown"] a:has(img){display:flex;align-items:center} atom-markdown button[data-mention],[data-is="atom-markdown"] button[data-mention]{background-color:rgba(123,203,243,0.18);border-radius:2px;padding:0px 4px;margin-bottom:2px;color:#0f7fd0;transition:84ms} atom-markdown button[data-mention]:hover,[data-is="atom-markdown"] button[data-mention]:hover{color:#18487d;background-color:rgba(11,120,244,0.16) !important} atom-markdown .github-user,[data-is="atom-markdown"] .github-user{display:flex;align-items:center;margin-bottom:4px} atom-markdown .github-user .github-user-icon,[data-is="atom-markdown"] .github-user .github-user-icon{margin-right:4px} atom-markdown .github-user .github-user-icon img,[data-is="atom-markdown"] .github-user .github-user-icon img{width:28px;height:28px;border-radius:50%} atom-markdown em,[data-is="atom-markdown"] em{font-style:normal;padding:0 .12em;color:black;background-image:linear-gradient(to bottom, transparent 65%, #4466ea61 35%);background-size:100% 50%;background-position:0 75%}', '', function(opts) {
    const SANITIZE_OPTIONS = {
      allowedTags: [ 'p','iframe', 'b', 'i', 'em', 'strong', 'a', 'span', 'br', 'div', 'img', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'table', 'tr', 'td', 'th', 'thead', 'tbody', 'code', 'pre', 'ul', 'ol', 'li', 'blockquote', 'hr', 'del', 'atom-mention', 'atom-message-block', 'input', 'label', 'button'],
      allowedAttributes: {
        'button': ['button', 'data-*'],
        'a': [ 'href' ],
        'img': [ 'src', 'alt' ],
        'span': [ 'class', 'data-*', 'title' ],
        'atom-mention': [ 'name' ],
        'li': [ 'class', 'data-*' ],
        'input': [ 'type', 'checked' ],
        'label': [ 'class' ],
        'iframe': ['width', 'height', 'src'],
        'div': [ 'class' ],
      },
      allowedIframeHostnames: [
        'www.youtube.com',
        'wiary.team',
      ],
      disallowedTagsMode: 'escape',
    };
    this.mixin('enableOptsEventHandler');

    this.messageBlockTags = [];

    this.unmountMessageBlocks = () => {
      this.messageBlockTags.forEach(tag => tag.unmount());
      this.messageBlockTags = [];
    };

    this.mountMessageBlocks = () => {
      this.unmountMessageBlocks();

      const message_nodes = this.root.querySelectorAll('atom-message-block');
      if (!message_nodes.length) return;

      Array.from(message_nodes).forEach((node) => {
        const text = node.textContent || '';
        node.textContent = '';

        const [tag] = riot.mount(node, 'atom-message-block', { text });
        if (tag) this.messageBlockTags.push(tag);
      });
    };
    this.on('mount', () => {
      this.root.addEventListener('click', async (e) => {
        const target = e.target;
        let anchor, image, button;

        if (anchor = target.closest('a')) {
          e.preventDefault();
          e.stopPropagation();

          if (!capacitor.isAvailable && (e.shiftKey || e.metaKey || e.ctrlKey)) {
            const url = new URL(anchor, location.origin);
            let is_note_url = app.utils.isNoteUrl(url);

            if (is_note_url) {
              url.searchParams.set('view', 'list');
            }
            open(url.href);
          }

          else {
            app.utils.openMarkdownLink(anchor);
          }
        }
        else if (image = target.closest('img')) {
          e.preventDefault();
          e.stopPropagation();

          if(image.parentElement && image.parentElement.href) return;

          const src = image.getAttribute('src');
          spat.modal.open('modal-imageviewer', {image: src});
        }
        else if (button = target.closest('button')) {
          e.preventDefault();
          e.stopPropagation();
          const screen_name = button.getAttribute('data-mention');
          if (screen_name) {
            this.trigger('mentionclick', { originalEvent: e, screenName: screen_name });
          }
        }
      });
      this.setContent(this.opts.content);
    });

    this.on('update', () => {
      this.setContent(this.opts.content);
    });

    this.setContent = (content) => {

      if (!content) {
        this.unmountMessageBlocks();
        this.root.innerHTML = '';
        this.content = null;
      }
      else if (this.content != content ) {
        this.content = content;

        const renderer = new marked.Renderer();

        renderer.text = (text) => {
          return text.replace(/(^|\s)@([\w-]+)/g, '$1<button type="button" data-mention="$2">@$2</button>');
        };

        renderer.code = (code, infostring) => {
          const type = (infostring || '').trim().split(/\s+/)[0];
          if (type === 'message') {
            const safe_text = (code || '').replace(/[&<>"]/g, (ch) => ({
              '&': '&amp;',
              '<': '&lt;',
              '>': '&gt;',
              '"': '&quot;',
            }[ch]));
            return `<div class="my12"><atom-message-block>${safe_text}</atom-message-block></div>`;
          }
          return marked.Renderer.prototype.code.call(renderer, code, infostring);
        };

        content = marked(content, {
          breaks: true,
          renderer,
        });

        content = sanitizeHtml(content, SANITIZE_OPTIONS);

        this.unmountMessageBlocks();
        this.root.innerHTML = content;
        this.mountMessageBlocks();
        this.setCodeElm();
      }
    };

    this.setCodeElm = () => {
      const $code = this.root.querySelectorAll('pre code');
      if (!$code.length) return ;
      Array.from($code).forEach(elm => {

        window.hljs?.highlightElement(elm);

        let $copy = document.createElement('i');
        $copy.classList.add('material-icons', 'absolute', 't12', 'r4', 'p8', 'fs16', 'text-label_dark_medium', 'cursor-pointer', 'hover-show');
        $copy.innerText = 'content_copy';
        $copy.onclick = () => {
          let content = elm.innerText.trim();
          navigator.clipboard.writeText(content);
          spat.toast.message('コピーしました');
        };
        elm.parentElement.classList.add('hover-trigger');
        elm.parentElement.appendChild($copy);
      });
    };

    this.on('update', () => {
      let links = Array.from(this.root.querySelectorAll('a'));

      links.forEach((link) => {

        try {
          let url = new URL(link.innerText);

          if (link.href !== url.href) {
            link.classList.add('with-icon');
          }
        }

        catch {
          link.classList.add('with-icon');
        }
      });
    });
});